import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Typography, Button } from "@mui/material";
import { withStyles } from "tss-react/mui";
import styles from "./styles";

function NotFound(props) {
  const { classes } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={classes.root}>
      <Container maxWidth="md" className={classes.container}>
        <Typography component="p" className={classes.eyebrow}>
          404
        </Typography>
        <Typography component="h1" className={classes.title}>
          Page not found.
        </Typography>
        <Typography component="p" className={classes.text}>
          The page you are looking for is not available. Head back to the WSI home page.
        </Typography>
        <Button
          nativeButton={false}
          component={Link}
          to="/"
          variant="contained"
          className={classes.button}
        >
          Back Home
        </Button>
      </Container>
    </div>
  );
}

export default withStyles(NotFound, styles);
